'use client'

import styled from 'styled-components'

import theme from '@/src/config/theme'

import Button from '@/src/shared/ui/button'

export const Card = styled.div`
  display: flex;
  flex-direction: column;

  border: solid 1px ${theme.colors.borderColor};
  border-radius: 5px;

  div {
    white-space: normal;
    word-wrap: break-word;
  }
`

export const Image = styled.div`
  position: relative;
  display: flex;
  justify-content: center;

  img {
    width: 100%;
    height: auto;
    max-height: 250px;
    object-fit: cover;
  }
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;

  padding: 20px;
`

export const ShopName = styled.div`
  font-size: 1.25rem;
  font-weight: 450;
`

export const ShopAddress = styled.div`
  padding-top: 10px;
`

export const ShopSchedule = styled.div`
  padding-top: 5px;
`
export const Description = styled.div`
  padding-top: 5px;
`
export const ShopPhone = styled.div`
  padding-top: 5px;
`
export const ShopEmail = styled.div`
  padding-top: 5px;
`

export const SeeButton = styled(Button)`
  padding-left: unset;
  padding-right: unset;

  border-top-style: unset;
  border-left-style: unset;
  border-right-style: unset;

  border-radius: unset;

  font-weight: 450;

  width: fit-content;
`

export const CityShortName = styled.div`
  position: absolute;

  right: 20px;
  padding: 10px 10px;

  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;

  background: ${theme.colors.primary};

  font-weight: 450;
`
